class WatchableStore {
  provider;
  handlers = /* @__PURE__ */ new Set();
  constructor(provider) {
    this.provider = provider;
  }
  async get(key) {
    return this.provider.get(key);
  }
  async set(key, value) {
    const oldValue = await this.provider.get(key);
    this.provider.set(key, value);
    for (const handler of this.handlers) {
      handler(key, value, oldValue);
    }
  }
  async has(key) {
    return this.provider.has(key);
  }
  async delete(key) {
    return this.provider.delete(key);
  }
  watch(handler) {
    this.handlers.add(handler);
    return () => {
      this.handlers.delete(handler);
    };
  }
  unwatch() {
    this.handlers = /* @__PURE__ */ new Set();
  }
}
export {
  WatchableStore
};
//# sourceMappingURL=WatchableStore.js.map
